/**
 * @param {Array} collect - List of objects to filter
 * @param {Array} idsToMatch - A list of ids we want to filter on
 * @returns {Array} Array of objects with ids that match the idsToMatch array
 */
export default function MatchIds() {
    return function (collection, idsToMatch) {
        // If there's no filters then return no results;
        if (!idsToMatch || idsToMatch.length === 0) {
            return [];
        }

        // Otherwise return objects with ids that match the idsToMatch array
        return collection.filter((item) => idsToMatch.indexOf(item.id) > -1);
    };
}
